import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import PreloaderInner from "../../components/preloader/loader";
import influencerTwitter from "../../assets/influencerTwitter.png";
import "./../../components/nftCards/NFTCards.css";
import firebase from "./../../firebase";
import profilePage from "../../assets/defaultProfile.jpg";
import logo from "../../assets/logo.png";
import { useHistory } from "react-router-dom";

function Creators({ creator }) {
  const history = useHistory();
  return (
    <>
      <div className="cards nft-cards nft-cards-cr">
        {creator &&
          creator.map((item) => {
            return (
              <div
                className="card nft-card cnftcard"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push(`/profile/${item.username}`);
                }}
              >
                <img
                  src={item.imageURL ? item.imageURL : profilePage}
                  alt="Influencer"
                  className="influencer-image"
                />
                <div className="influencer-details">
                  <img
                    src={logo}
                    alt="Influencer Twitter"
                    style={{ width: "50px", marginTop: "5px" }}
                  />
                  <p>
                    {item.walletAddress &&
                      item.walletAddress.substr(0, 4) +
                        ".................." +
                        item.walletAddress.slice(-4)}
                  </p>
                  <p className="yellow">{item.name && item.name} </p>
                  <p className="followers">{item.username && item.username}</p>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default Creators;
